/**
 * assets/mijn-vijverprofiel.js, v4: de voordeur van Mijn Vijver (16-10-2026, B-2026-10-16-2)
 * Gedrag van sections/mijn-vijverprofiel.liquid, alleen voor wie niet is ingelogd (ingelogd stuurt de sectie door).
 *
 * 1. Drie vragen met de codes van CONTRACT Vijverprofiel 2.0 versie 2: vijver.type, vijver.grootte ("onbekend"
 *    wordt null) en de bewoners (meerkeuze, "geen_vissen" sluit de rest uit). Daarna direct advies.
 * 2. "Inloggen en profiel bewaren" zet de antwoorden als kaartwaarden in localStorage (VOORLOPIG_SLEUTEL) en
 *    opent het inloggen. Na het inloggen slaat assets/vijverprofiel.js ze op Mijn Vijver op via de route
 *    /apps/vp/plus/vijverprofiel (ondertekend door Shopify), alleen in kaarten die nog leeg zijn.
 *    Liters (23-10-2026, verbruikscalculator): de kaart vijver mag ook liters bevatten (geheel getal, 50 tot en met
 *    1.000.000, nooit tekst). Die schrijft de calculator onder de koopknop (assets/product-verbruik-liters.js) in
 *    dezelfde sleutel; deze vragenlijst laat ze door en wist ze niet, zolang ze bij de grootte passen die de klant
 *    hier kiest. De grootteklasse volgt de liters (anders wijst de lezer in assets/vijverprofiel.js de kaart af).
 * 3. Niet meer: de zes oude vragen, de oude profielroute zonder identiteitscontrole (VP-8.14 en VP-8.29),
 *    een e-mailveld, klant-id of e-mail in de pagina, Klaviyo-aanroepen met $email of $consent.
 * Meting: GA4 mijn_vijver_step en mijn_vijver_completed (alleen codes), alleen na toestemming voor analytics,
 * niet bij Global Privacy Control en niet in de editor (zelfde regel als assets/mijn-vijver-link.js).
 * Het pure deel staat op window.MijnVijverprofiel voor de tests (tests/vragenlijst-voordeur.test.js).
 */
(function (root) {
  'use strict';

  /* ── 1. Puur: codes, kaartwaarden, advies ── */
  var VOORLOPIG_SLEUTEL = 'vc_vp_voorlopig';
  var SESSIE_SLEUTEL = 'mv_vragenlijst_v4';
  var OUDE_SESSIE = 'mv_check_progress';
  var SESSIE_DAGEN = 7;
  var LITERS = { min: 50, max: 1000000 };
  var STAPPEN = ['type', 'grootte', 'bewoners'];
  var CODES = {
    type: ['koivijver', 'siervijver', 'natuurvijver', 'plantenvijver', 'zwemvijver', 'gemengd', 'onbekend'],
    grootte: ['under_3000', '3000_8000', '8000_20000', 'over_20000', 'onbekend'],
    bewoners: ['koi', 'goudvis', 'sterlet', 'winde', 'inheems', 'anders', 'geen_vissen']
  };
  var LABEL = {
    type: { koivijver: 'Koivijver', siervijver: 'Siervijver', natuurvijver: 'Natuurvijver', plantenvijver: 'Plantenvijver', zwemvijver: 'Zwemvijver', gemengd: 'Gemengd', onbekend: 'Weet ik niet' },
    grootte: { under_3000: 'Tot 3.000 liter', '3000_8000': '3.000 tot 8.000 liter', '8000_20000': '8.000 tot 20.000 liter', over_20000: 'Meer dan 20.000 liter', onbekend: 'Weet ik niet' },
    bewoners: { koi: 'Koi', goudvis: 'Goudvissen', sterlet: 'Sterlet', winde: 'Winde', inheems: 'Inheemse vissen', anders: 'Andere vissen', geen_vissen: 'Geen vissen' }
  };
  var KOP = { type: 'Soort vijver', grootte: 'Grootte', bewoners: 'Bewoners' };

  function heeft(lijst, w) { return lijst.indexOf(w) !== -1; }
  function isObject(o) { return o !== null && typeof o === 'object' && !Array.isArray(o); }

  /* Liters: een getal, geheel, binnen de grenzen van het contract. "8000" (tekst) telt niet. */
  function litersGeldig(x) {
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x && x >= LITERS.min && x <= LITERS.max;
  }
  /* Gelijk aan grootteUitLiters in assets/vijverprofiel.js (tests/vragenlijst-voordeur.test.js vergelijkt ze). */
  function grootteUitLiters(l) {
    if (!litersGeldig(l)) return null;
    if (l < 3000) return 'under_3000';
    if (l < 8000) return '3000_8000';
    if (l < 20000) return '8000_20000';
    return 'over_20000';
  }
  /* De liters uit een eerder bewaard voorlopig object (de calculator), als dat nog geldig is: versie 1, binnen zeven
     dagen, liters als getal. Zelfde regels als voorlopigGeldig in assets/vijverprofiel.js. */
  function eerderLiters(eerder, nuMs) {
    if (!isObject(eerder) || eerder.versie !== 1 || typeof eerder.ts !== 'number' || !isFinite(eerder.ts)) return null;
    if (eerder.ts > nuMs + 60000 || nuMs - eerder.ts > SESSIE_DAGEN * 86400000 || !isObject(eerder.kaarten)) return null;
    var v = eerder.kaarten.vijver;
    return isObject(v) && litersGeldig(v.liters) ? v.liters : null;
  }

  /* Alleen bekende codes; de bewoners als unieke lijst, "geen_vissen" alleen. */
  function schoon(antw) {
    var a = isObject(antw) ? antw : {};
    var u = {};
    if (heeft(CODES.type, a.type)) u.type = a.type;
    if (heeft(CODES.grootte, a.grootte)) u.grootte = a.grootte;
    if (Array.isArray(a.bewoners)) {
      var b = [];
      a.bewoners.forEach(function (c) { if (heeft(CODES.bewoners, c) && !heeft(b, c)) b.push(c); });
      if (heeft(b, 'geen_vissen')) b = ['geen_vissen'];
      if (b.length) u.bewoners = b;
    }
    if (litersGeldig(a.liters)) u.liters = a.liters;
    return u;
  }
  function compleet(antw) {
    var a = schoon(antw);
    return !!(a.type && a.grootte && a.bewoners);
  }

  /* De kaartwaarden van Vijverprofiel 2.0 (precies de sleutels van het contract). */
  function kaarten(antw) {
    var a = schoon(antw);
    var b = a.bewoners || [];
    var geen = b.length === 1 && b[0] === 'geen_vissen';
    return {
      vijver: {
        type: a.type || null, liters: a.liters || null,
        grootte: a.liters ? grootteUitLiters(a.liters) : (a.grootte && a.grootte !== 'onbekend' ? a.grootte : null),
        diepte: null, zon: null, bomen: null, aangelegd: null
      },
      bewoners: {
        geen_vissen: geen,
        soorten: geen ? [] : b.map(function (s) { return { soort: s, aantal: 'onbekend', lengte: null }; })
      }
    };
  }
  /* De liters van de calculator blijven staan als de klant ze hier niet zelf opgeeft en ze bij de gekozen grootte
     passen ("weet ik niet" past bij alles). Past het niet, dan wint wat de klant nu kiest en vervallen de liters. */
  function voorlopig(antw, nuMs, eerder) {
    var a = schoon(antw);
    var l = a.liters ? null : eerderLiters(eerder, nuMs);
    if (l !== null && (!a.grootte || a.grootte === 'onbekend' || a.grootte === grootteUitLiters(l))) a.liters = l;
    return { versie: 1, ts: nuMs, bron: 'vragenlijst', kaarten: kaarten(a) };
  }

  /* ── Advies ── */
  var BASIS = {
    koivijver: [
      { naam: 'Koivoer', tekst: 'Voer dat past bij de watertemperatuur', url: '/collections/koi-visvoer' },
      { naam: 'Watertests', tekst: 'Koi-houders meten hun water bij voorkeur elke week', url: '/collections/water-testen-meten' },
      { naam: 'Vijverfilters en UV-C', tekst: 'Koi vragen om een filter dat ruim genoeg is voor je vijver', url: '/collections/vijverfilters-uvc' }
    ],
    siervijver: [
      { naam: 'Waterverzorging', tekst: 'Het hele jaar helder water, met regelmatig meten', url: '/collections/waterkwaliteit-onderhoud' },
      { naam: 'Waterplanten', tekst: 'Planten nemen voedingsstoffen op die anders naar algen gaan', url: '/collections/waterplanten' },
      { naam: 'Vijververlichting', tekst: 'Geniet ook \'s avonds van je vijver', url: '/collections/vijververlichting' }
    ],
    natuurvijver: [
      { naam: 'Waterplanten', tekst: 'Veel planten geven een stabiel evenwicht', url: '/collections/waterplanten' },
      { naam: 'Vijverranden', tekst: 'Natuurlijke oevers bieden schuilplaatsen voor dieren', url: '/collections/vijverfolie-aanleg' },
      { naam: 'Slib verwijderen', tekst: 'Ons advies: een tot twee keer per jaar voorzichtig weghalen', url: '/collections/bodemslib-verwijderen' }
    ],
    plantenvijver: [
      { naam: 'Waterplanten', tekst: 'Waterlelies, moerasplanten en drijvers', url: '/collections/waterplanten' },
      { naam: 'Waterverzorging', tekst: 'Te veel voeding geeft algen, te weinig zwakke planten', url: '/collections/waterkwaliteit-onderhoud' },
      { naam: 'Plantenvoeding', tekst: 'Bloeien je waterlelies niet? Geef ze plantenvoeding', url: '/collections/aquarium-plantenvoeding' }
    ],
    zwemvijver: [
      { naam: 'Waterplanten', tekst: 'In een zwemvijver zuiveren planten het water', url: '/collections/waterplanten' },
      { naam: 'Slib verwijderen', tekst: 'Ons advies: een tot twee keer per jaar weghalen', url: '/collections/bodemslib-verwijderen' },
      { naam: 'Watertests', tekst: 'Meet regelmatig, dan zie je op tijd wat verandert', url: '/collections/water-testen-meten' }
    ],
    gemengd: [
      { naam: 'Vijverfilters en UV-C', tekst: 'Een gemengde vijver vraagt een filter dat alles aankan', url: '/collections/vijverfilters-uvc' },
      { naam: 'Waterverzorging', tekst: 'Regelmatig meten voorkomt verrassingen', url: '/collections/waterkwaliteit-onderhoud' },
      { naam: 'Visvoer', tekst: 'Voer dat past bij je vissen en het seizoen', url: '/collections/koi-visvoer' }
    ],
    onbekend: [
      { naam: 'Vijverkennis', tekst: 'Eerst uitzoeken wat je wilt, dan pas investeren in techniek', url: '/pages/vijverkennis' },
      { naam: 'Waterverzorging', tekst: 'Gezond water is voor elke vijver de basis', url: '/collections/waterkwaliteit-onderhoud' },
      { naam: 'Persoonlijk advies', tekst: 'Stuur een foto en een beschrijving, we denken met je mee', url: '/pages/contact' }
    ]
  };
  /* Voerteksten volgens de huisregel (thema #225): onder 5 graden niet voeren, 5 tot 8 alleen wintervoer,
     8 tot 15 tarwekiem. */
  var SEIZOEN = {
    koi: {
      lente: { naam: 'Tarwekiemvoer (voorjaar)', tekst: 'Onder 5°C nog niet voeren, tussen 5 en 8°C alleen wintervoer, vanaf 8°C tarwekiemvoer.', url: '/collections/koi-visvoer' },
      zomer: { naam: 'Groeiseizoen', tekst: 'In de zomer groeivoer met meer eiwit voor je koi.', url: '/collections/koi-visvoer' },
      herfst: { naam: 'Herfstvoer en wintervoorbereiding', tekst: 'Daalt de watertemperatuur? Tarwekiemvoer tot 8°C, tussen 8 en 5°C alleen wintervoer, onder 5°C niet voeren.', url: '/collections/koi-visvoer' },
      winter: { naam: 'IJsvrijhouder en beluchting', tekst: 'Houd een wak open voor de gasuitwisseling.', url: '/collections/vijververwarming-ijsvrijhouders' }
    },
    natuurvijver: {
      lente: { naam: 'Laat je vijver in het voorjaar rustig', tekst: 'In maart planten kikkers zich voort. Niet storen, dat is een goed teken.', url: '/pages/vijverkennis' },
      zomer: { naam: 'Libellenseizoen', tekst: 'Veel libellen wijzen op een gezonde vijver.', url: '/collections/waterplanten' },
      herfst: { naam: 'Herfstnet plaatsen', tekst: 'Vang vallende bladeren op voor ze op de bodem rotten.', url: '/collections/vijver-herfstklaar' },
      winter: { naam: 'Winterrust', tekst: 'Laat de natuur zijn gang gaan en grijp zo min mogelijk in.', url: '/pages/vijverkennis' }
    },
    algemeen: {
      lente: { naam: 'Voorjaarscheck', tekst: 'Controleer pomp, filter en techniek na de winter.', url: '/collections/vijveraanleg' },
      zomer: { naam: 'Zomeronderhoud', tekst: 'Houd de algengroei in de gaten en meet regelmatig.', url: '/collections/waterkwaliteit-onderhoud' },
      herfst: { naam: 'Winterklaar maken', tekst: 'Bereid je vijver voor op de koude maanden.', url: '/collections/vijver-herfstklaar' },
      winter: { naam: 'IJsvrijhouder', tekst: 'Houd een wak open voor de gasuitwisseling.', url: '/collections/vijververwarming-ijsvrijhouders' }
    }
  };
  function seizoen(datum) {
    var m = (datum && typeof datum.getMonth === 'function' ? datum : new Date()).getMonth();
    if (m >= 2 && m <= 4) return 'lente';
    if (m >= 5 && m <= 7) return 'zomer';
    if (m >= 8 && m <= 10) return 'herfst';
    return 'winter';
  }
  function seizoenTip(antw, datum) {
    var a = schoon(antw);
    var koi = a.type === 'koivijver' || heeft(a.bewoners || [], 'koi');
    var groep = koi ? 'koi' : a.type === 'natuurvijver' ? 'natuurvijver' : 'algemeen';
    return SEIZOEN[groep][seizoen(datum)];
  }
  function advies(antw, datum) {
    var a = schoon(antw);
    var lijst = (BASIS[a.type] || BASIS.onbekend).slice();
    var tip = seizoenTip(a, datum);
    if (tip && !lijst.some(function (r) { return r.url === tip.url; })) lijst.push(tip);
    return lijst;
  }

  var MVP = {
    VOORLOPIG_SLEUTEL: VOORLOPIG_SLEUTEL, STAPPEN: STAPPEN, CODES: CODES, LABEL: LABEL,
    LITERS: LITERS, litersGeldig: litersGeldig, grootteUitLiters: grootteUitLiters, eerderLiters: eerderLiters,
    schoon: schoon, compleet: compleet, kaarten: kaarten, voorlopig: voorlopig,
    seizoen: seizoen, seizoenTip: seizoenTip, advies: advies
  };
  root.MijnVijverprofiel = MVP;

  /* ── 2. De pagina ── */
  if (typeof document === 'undefined' || !document.getElementById) return;
  var app = document.getElementById('mvApp');
  if (!app) return;

  var antw = {};
  var stap = 1;

  function opslag() { try { return root.localStorage || null; } catch (e) { return null; } }
  function lees(sleutel) { var s = opslag(); try { return s ? s.getItem(sleutel) : null; } catch (e) { return null; } }
  function schrijf(sleutel, waarde) { var s = opslag(); try { if (s) s.setItem(sleutel, waarde); } catch (e) { /* privémodus */ } }
  function wis(sleutel) { var s = opslag(); try { if (s) s.removeItem(sleutel); } catch (e) { /* niets */ } }

  function toestemming() {
    if (root.navigator && root.navigator.globalPrivacyControl === true) return false;
    if (root.Shopify && root.Shopify.designMode) return false;
    var cp = root.Shopify && root.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() === true;
    return false;
  }
  function meet(naam, p) {
    if (!toestemming() || typeof root.gtag !== 'function') return;
    try { root.gtag('event', naam, p); } catch (e) { /* meting is bijzaak */ }
  }

  /* Een oude sessie (zes vragen, ander formaat) gaat weg; die past niet meer. */
  wis(OUDE_SESSIE);
  function bewaarSessie() { schrijf(SESSIE_SLEUTEL, JSON.stringify({ antw: schoon(antw), stap: stap, ts: Date.now() })); }
  function leesSessie() {
    var ruw = lees(SESSIE_SLEUTEL);
    if (!ruw) return null;
    var d = null;
    try { d = JSON.parse(ruw); } catch (e) { d = null; }
    if (!isObject(d) || typeof d.ts !== 'number' || Date.now() - d.ts > SESSIE_DAGEN * 86400000) { wis(SESSIE_SLEUTEL); return null; }
    var s = Math.floor(Number(d.stap));
    if (!(s >= 1 && s <= STAPPEN.length)) s = 1;
    return { antw: schoon(d.antw), stap: s };
  }

  function el(id) { return document.getElementById(id); }
  function stapEl(n) { return app.querySelector('.mv-step[data-step="' + n + '"]'); }
  function groep(veld) { return app.querySelector('[data-field="' + veld + '"]'); }
  function beantwoord(veld) {
    var w = schoon(antw)[veld];
    return Array.isArray(w) ? w.length > 0 : !!w;
  }

  function tekenKeuzes() {
    STAPPEN.forEach(function (veld) {
      var g = groep(veld);
      if (!g) return;
      var w = schoon(antw)[veld];
      Array.prototype.forEach.call(g.querySelectorAll('.mv-option'), function (o) {
        var aan = Array.isArray(w) ? heeft(w, o.getAttribute('data-value')) : w === o.getAttribute('data-value');
        o.classList.toggle('selected', aan);
        o.setAttribute('aria-pressed', aan ? 'true' : 'false');
      });
      var n = STAPPEN.indexOf(veld) + 1;
      var knop = el('mvNext' + n);
      if (knop) knop.disabled = !beantwoord(veld);
    });
  }
  function toonStap(n) {
    for (var i = 1; i <= STAPPEN.length; i++) {
      var s = stapEl(i);
      if (s) s.classList.toggle('mv-hidden', i !== n);
    }
    stap = n;
    var vul = el('mvProgressFill');
    if (vul) vul.style.width = (n / STAPPEN.length * 100) + '%';
    var tekst = el('mvProgressLabel');
    if (tekst) tekst.textContent = 'Vraag ' + n + ' van ' + STAPPEN.length;
    tekenKeuzes();
  }
  function naarBoven() {
    try { root.scrollTo({ top: app.getBoundingClientRect().top + (root.pageYOffset || 0) - 20, behavior: 'smooth' }); } catch (e) { /* oud */ }
  }

  function kies(optie) {
    var g = optie.parentElement;
    var veld = g && g.getAttribute('data-field');
    if (!heeft(STAPPEN, veld)) return;
    var w = optie.getAttribute('data-value');
    if (g.getAttribute('data-multi') === 'true') {
      var lijst = Array.isArray(antw[veld]) ? antw[veld].slice() : [];
      if (w === 'geen_vissen') lijst = heeft(lijst, w) ? [] : [w];
      else {
        lijst = lijst.filter(function (c) { return c !== 'geen_vissen'; });
        lijst = heeft(lijst, w) ? lijst.filter(function (c) { return c !== w; }) : lijst.concat(w);
      }
      antw[veld] = lijst;
    } else {
      antw[veld] = w;
    }
    antw = schoon(antw);
    tekenKeuzes();
    bewaarSessie();
  }

  function volgende(n) {
    var veld = STAPPEN[n - 1];
    if (!beantwoord(veld)) return;
    meet('mijn_vijver_step', { step: n, field: veld, versie: 'voordeur-1' });
    if (n < STAPPEN.length) { toonStap(n + 1); bewaarSessie(); naarBoven(); return; }
    klaar();
  }
  function terug(n) { if (n > 1) { toonStap(n - 1); bewaarSessie(); naarBoven(); } }

  function maak(tag, klasse, tekst) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (tekst != null) e.textContent = tekst;
    return e;
  }

  function klaar() {
    if (!compleet(antw)) return;
    var a = schoon(antw);
    meet('mijn_vijver_completed', { type: a.type, grootte: a.grootte, bewoners: a.bewoners.join(','), versie: 'voordeur-1' });
    el('mvForm').classList.add('mv-hidden');
    var r = el('mvRestore');
    if (r) r.classList.add('mv-hidden');

    var kaart = el('mvProfileCard');
    kaart.textContent = '';
    kaart.appendChild(maak('h3', 'text-base font-display font-bold text-aqua-donker mb-4', 'Jouw vijver'));
    var rooster = maak('div', 'grid grid-cols-2 sm:grid-cols-3 gap-3');
    STAPPEN.forEach(function (veld) {
      var w = a[veld];
      var tekst = Array.isArray(w) ? w.map(function (c) { return LABEL[veld][c]; }).join(', ') : LABEL[veld][w];
      var vak = maak('div', 'bg-aqua/5 rounded-xl p-3');
      vak.appendChild(maak('div', 'text-[11px] uppercase tracking-wide text-slate-500 mb-1', KOP[veld]));
      vak.appendChild(maak('div', 'text-sm font-semibold text-navy', tekst));
      rooster.appendChild(vak);
    });
    kaart.appendChild(rooster);

    var grid = el('mvRecoGrid');
    grid.textContent = '';
    advies(a, new Date()).forEach(function (rec) {
      var link = maak('a', 'block bg-white border border-slate-200 rounded-xl p-4 text-center no-underline text-navy hover:border-aqua hover:shadow-sm transition-all');
      link.setAttribute('href', rec.url);
      link.appendChild(maak('div', 'text-sm font-semibold mb-1', rec.naam));
      link.appendChild(maak('div', 'text-xs text-slate-500', rec.tekst));
      grid.appendChild(link);
    });

    var tip = seizoenTip(a, new Date());
    var tipEl = el('mvSeasonalTip');
    if (tip && tipEl) {
      tipEl.textContent = '';
      var vak = maak('div', 'p-4 bg-aqua/5 rounded-xl border border-aqua/10');
      vak.appendChild(maak('div', 'text-sm font-semibold text-navy mb-1', 'Tip voor dit seizoen'));
      vak.appendChild(maak('div', 'text-sm text-gray-600', tip.tekst));
      tipEl.appendChild(vak);
      tipEl.classList.remove('mv-hidden');
    }

    var res = el('mvResult');
    res.classList.remove('mv-hidden');
    try { res.focus({ preventScroll: true }); } catch (e) { /* oud */ }
    naarBoven();
  }

  /* Bewaren: de antwoorden als kaartwaarden in deze browser, daarna opent de link het inloggen. */
  function bewaar() {
    if (!compleet(antw)) return;
    var eerder = null;
    try { eerder = JSON.parse(lees(VOORLOPIG_SLEUTEL)); } catch (e) { eerder = null; }
    schrijf(VOORLOPIG_SLEUTEL, JSON.stringify(voorlopig(antw, Date.now(), eerder)));
    wis(SESSIE_SLEUTEL);
  }

  function deel(knop) {
    var url = root.location.origin + root.location.pathname;
    if (root.navigator && root.navigator.share) {
      root.navigator.share({ title: 'Maak je Vijverprofiel, Vijvercentrum.nl', text: 'Drie vragen over je vijver en direct advies.', url: url }).catch(function () {});
    } else if (root.navigator && root.navigator.clipboard) {
      root.navigator.clipboard.writeText(url).then(function () {
        var oud = knop.textContent;
        knop.textContent = 'Link gekopieerd';
        setTimeout(function () { knop.textContent = oud; }, 2000);
      }, function () {});
    }
  }

  app.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var o = t.closest('.mv-option');
    if (o) { kies(o); return; }
    var v = t.closest('[data-mv-volgende]');
    if (v) { volgende(Number(v.getAttribute('data-mv-volgende'))); return; }
    var b = t.closest('[data-mv-terug]');
    if (b) { terug(Number(b.getAttribute('data-mv-terug'))); return; }
    if (t.closest('#mvBewaarKnop')) { bewaar(); return; }
    var f = t.closest('[data-mv-faq]');
    if (f) {
      var open = !f.classList.contains('open');
      f.classList.toggle('open', open);
      f.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (f.nextElementSibling) f.nextElementSibling.classList.toggle('open', open);
      return;
    }
    var actie = t.closest('[data-mv-actie]');
    if (!actie) return;
    var soort = actie.getAttribute('data-mv-actie');
    if (soort === 'verder') { el('mvRestore').classList.add('mv-hidden'); toonStap(stap); }
    else if (soort === 'opnieuw') { antw = {}; wis(SESSIE_SLEUTEL); el('mvRestore').classList.add('mv-hidden'); toonStap(1); }
    else if (soort === 'delen') deel(actie);
  });

  /* Start: een eerdere sessie biedt verdergaan aan. */
  var eerder = leesSessie();
  if (eerder && (eerder.stap > 1 || Object.keys(eerder.antw).length)) {
    antw = eerder.antw;
    stap = eerder.stap;
    var nr = el('mvRestoreStep');
    if (nr) nr.textContent = String(stap);
    var banner = el('mvRestore');
    if (banner) banner.classList.remove('mv-hidden');
    toonStap(1);
    stap = eerder.stap;
  } else {
    toonStap(1);
  }
})(typeof window !== 'undefined' ? window : this);
